import script from "./FixedIdentifyPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./FixedIdentifyPopup.vue?vue&type=script&lang=ts&setup=true"

import "./FixedIdentifyPopup.vue?vue&type=style&index=0&id=f38ae2ba&lang=scss"
import "./FixedIdentifyPopup.vue?vue&type=style&index=1&id=f38ae2ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f38ae2ba"]])

export default __exports__